import type { RouteRecordRaw } from "vue-router";


export const FormRoutes: RouteRecordRaw[] = [
    {
        path: ':nickname?/:hash',
        name: 'formFirstStage',
        component: () => import('./components/FormFill.vue')
    },
    {
        path: ':nickname?/stage/:hash',
        name: 'formStage',
        component: () => import('./components/FormFill.vue')
    },
]